import { BffResourceResponse, META_PERMISSIONS_MAP, MetaMap } from '@actiris/bff';
import { AppPermissions } from '@core/bff/app-permissions';

export function applyPermissions(resources: BffResourceResponse[], permissions: AppPermissions): AppPermissions {
    // get the metadata map containing the permissions definitions
    const map = Reflect.getMetadata(META_PERMISSIONS_MAP, permissions) as MetaMap<{
        resource: string;
        action: string;
        isAllowedByDefault: boolean;
    }>;

    if (!map || !resources) return permissions;

    return Object.entries(map).reduce(
        (instance, [propertyKey, opts]: [string, { resource: string; action: string; isAllowedByDefault: boolean }]) => {
            // find the corresponding resource and action in the resources array
            const resource = resources.find((r) => r.nom === opts.resource);
            const action = resource?.actions.find((a) => a.nom === opts.action);
            // check if the action is allowed or denied
            const isAllowed = action ? !action.deny : opts.isAllowedByDefault;

            // Add a getter property to the user object with the permission value
            return Object.defineProperty(instance, propertyKey, {
                get: () => isAllowed,
                enumerable: true,
            });
        },
        permissions,
    );
}
